export const numFormater = (num) => {
    return parseInt(num)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
